// Load status for any value fetched from the engine. `undefined` means not loaded yet; `null` and `[]` mean
// loaded and empty (src/hook/page.tsx usePageBlocks has always followed this). A recorded error wins.
export type LoadStatus = "loading" | "error" | "ready";

export const loadStatus = (value: unknown, error: string | undefined): LoadStatus => {
  if (error !== undefined) return "error";
  if (value === undefined) return "loading";
  return "ready";
};

// One key per thing being fetched, shared by the writer (trackLoad) and the reader (useLoadError).
export const loadKey = (kind: string, id: string): string => `${kind}:${id}`;
